import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { useAuth } from '../lib/auth';
import { toast } from 'sonner';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Willkommen, ${u.first_name}`);
      const target = u.role === 'admin' || u.role === 'staff' ? '/admin' : '/portal';
      navigate(location.state?.from || target, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="max-w-md mx-auto px-4 sm:px-6 py-10">
        <Card className="rounded-2xl border-slate-200">
          <CardContent className="p-6">
            <h1 className="font-heading font-semibold text-2xl text-[hsl(var(--primary))]">Anmelden</h1>
            <p className="text-sm text-slate-600 mt-1">Zugang zu Ihrem Kunden- oder Admin-Portal.</p>
            <form onSubmit={submit} className="mt-5 space-y-4">
              <div>
                <Label>E-Mail</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12 rounded-xl mt-1" data-testid="login-email-input" />
              </div>
              <div>
                <Label>Passwort</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12 rounded-xl mt-1" data-testid="login-password-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[hsl(var(--primary))] hover:bg-[hsl(210_73%_12%)] text-white" data-testid="login-submit-button">
                {loading ? 'Anmelden...' : 'Anmelden'}
              </Button>
            </form>
            <div className="mt-4 text-sm text-slate-600">
              Noch kein Konto? <Link to="/register" className="text-[hsl(var(--primary))] font-medium" data-testid="login-register-link">Registrieren</Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
